import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetAllChannels(searchValue) {
  return useQuery(['get-all-channels', searchValue], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.TASKBOARD_API, {
        search: searchValue,
      })
    );
    return res.data;
  });
}
